/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useMediaQuery } from "react-responsive";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/backgroundLogin.png";
import bgImageMobile from "assets/images/backgroundLoginMobile.png";
import singhCoinBrand from "assets/images/singhCoinBrand.png";
import businessSvg from "assets/images/business.svg";
import personalSvg from "assets/images/personal.svg";
import MDAvatar from "components/MDAvatar";

import validations from "customValidations/validations";
import validationService from "customValidations/validationService";
import { signIn } from "services/userService";
import { IconButton, InputAdornment, TextField } from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

function JoinUs() {
  const navigate = useNavigate();

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    checkIfLoggedIn();
  }, []);

  const checkIfLoggedIn = () => {
    if (localStorage.jwtTokenSingh) {
      navigate("/");
    }
  };

  const handleRegister = (name) => {
    if (name === "personal") {
      navigate("/sign-up-personal");
    } else {
      navigate("/sign-up-business");
    }
  };

  //   const customValidations = (name, value) => {
  //     let errorLength = 0;
  //     const args = [
  //       {
  //         name,
  //         value: value,
  //         validations: validations.signInValidations[name],
  //       },
  //     ];

  //     validationService.validate(args, (validationErr, validationErrMsgs) => {
  //       if (validationErrMsgs.length > 0) {
  //         errorLength = errorLength + 1;
  //         errorMsg[name].errorMsg = validationErrMsgs[0].validations[0].message;
  //         setErrorMsg({ ...errorMsg });
  //       } else {
  //         errorMsg[name].errorMsg = "";
  //         setErrorMsg({ ...errorMsg });
  //       }
  //     });
  //     return errorLength;
  //   };

  //   const handleShowPassword = () => setShowPassword(!showPassword);

  //   const handleInputChange = (name, value) => {
  //     if (name === "email") {
  //       setEmail(value);
  //     } else if (name === "password") {
  //       setPassword(value);
  //     } else {
  //       console.log("IputError");
  //     }
  //   };

  //   const handleLogin = async () => {
  //     let errorLengthEmail = customValidations("email", email);
  //     let errorLengthPassword = customValidations("password", password);

  //     console.log("erremail", errorLengthEmail);
  //     console.log("erropass", errorLengthPassword);
  //     console.log("email", email);
  //     console.log("password", password);

  //     if (errorLengthEmail !== 1 && errorLengthPassword !== 1) {
  //       console.log("Alll okkkkkkk");
  //     } else {
  //       console.log("Validation error");
  //       return;
  //     }

  //     const userData = {
  //       email: email,
  //       password: password,
  //     };

  //     const signInResponse = await signIn(userData);
  //     console.log("signInRes", signInResponse);

  //     if (signInResponse.status === 200) {
  //       navigate("/");
  //     }
  //   };

  return (
    <BasicLayout image={isDesktopOrLaptop ? bgImage : bgImageMobile}>
      <Card
        sx={{
          backgroundColor: "#ebebeb",
          boxShadow: "none",
          width: isTabletOrMobile ? "none" : "400px",
        }}
      >
        {/* <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MDAvatar src={singhCoinBrand} />
          </MDBox>

          <Grid
            container
            spacing={3}
            justifyContent="center"
            sx={{ mt: 1, mb: 2 }}
          >
            <Grid item xs={2}>
              <MDTypography
                component={MuiLink}
                href="#"
                variant="body1"
                color="white"
              >
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography
                component={MuiLink}
                href="#"
                variant="body1"
                color="white"
              >
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography
                component={MuiLink}
                href="#"
                variant="body1"
                color="white"
              >
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox> */}
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            sx={{
              marginBottom: "1rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MDAvatar
              src={singhCoinBrand}
              sx={{ height: "100px", width: "100px" }}
            />
          </MDBox>
          <MDBox sx={{ textAlign: "center", marginBottom: "2rem" }}>
            <MDTypography fontWeight="bold" color="text">
              Join Us!
            </MDTypography>
            <MDTypography fontWeight="bold" color="text">
              To begin, tell us what type of account you’d be opening.
            </MDTypography>
          </MDBox>
          <MDBox sx={{}}>
            <Card
              sx={{
                backgroundColor: "#ebebeb",
                padding: "1rem",
                marginBottom: "1rem",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "1rem",
                cursor: "pointer",
              }}
              onClick={() => handleRegister("personal")}
            >
              <MDAvatar
                src={personalSvg}
                sx={{ height: "60px", width: "60px" }}
              />
              <MDBox>
                <MDTypography fontWeight="bold" color="text">
                  Personal
                </MDTypography>
                <MDTypography
                  fontSize="15px"
                  color="text"
                  sx={{ lineHeight: "20px" }}
                >
                  Personal account to manage all your activity.
                </MDTypography>
              </MDBox>
            </Card>
            {/* <Card
              sx={{
                backgroundColor: "#ebebeb",
                padding: "1rem",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "1rem",
                cursor: "pointer",
              }}
              onClick={() => handleRegister("business")}
            >
              <MDAvatar
                src={personalSvg}
                sx={{ height: "60px", width: "60px" }}
              />
              <MDBox>
                <MDTypography fontWeight="bold" color="text">
                  Business
                </MDTypography>
                <MDTypography
                  fontSize="15px"
                  color="text"
                  sx={{ lineHeight: "20px" }}
                >
                  Own or belong to a company, this is for you.
                </MDTypography>
              </MDBox>
            </Card> */}
          </MDBox>
          {/* <MDBox component="form" role="form">
            <MDBox mb={2}>
              <TextField
                fullWidth
                name="email"
                label="Email"
                error={errorMsg.email.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.email.errorMsg}
              />
            </MDBox>
            <MDBox mb={2}>
              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                label="Password"
                name="password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => handleShowPassword()}>
                        {showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={errorMsg.password.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.password.errorMsg}
              />
            </MDBox>
            <MDBox display="flex" justifyContent="space-between">
              <MDBox display="flex" alignItems="center" ml={-1}>
                <Switch
                // checked={showPassword}
                // onChange={handleShowPassword}
                />
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  // onClick={handleShowPassword}
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Remember me
                </MDTypography>
              </MDBox>
              <MDBox>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                  // onClick={handleSetRememberMe}
                  sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                >
                  &nbsp;&nbsp;Forgot password?
                </MDTypography>
              </MDBox>
            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={() => handleLogin()}
              >
                sign in
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox> */}
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default JoinUs;
